export default class GA4Client {
  constructor(props = {}) {
    this.props = props;
    this.eventQueue = [];
    this.gtag = null;
    this.pollGtag();
  }

  pollGtag() {
    const maxAttempts = 10;
    let attempts = 0;

    const interval = setInterval(() => {
      if (typeof window.gtag === 'function') {
        this.gtag = window.gtag;
        this.flushQueue();
        clearInterval(interval);
      } else {
        attempts += 1;
        if (attempts >= maxAttempts) {
          Raven.captureException(new Error('GA4Client: gtag not available after polling.'));
          clearInterval(interval);
        }
      }
    }, 500);
  }

  flushQueue() {
    this.eventQueue.forEach(([event, props]) => {
      this.gtag('event', event, props);
    });
    this.eventQueue = [];
  }

  page(properties = {}) {
    const eventProps = {
      ...this.props,
      ...properties,
    };

    if (typeof this.gtag === 'function') {
      this.gtag('event', 'page_view', eventProps);
    } else {
      this.eventQueue.push(['page_view', eventProps]);
    }
  }
}
